import React from "react";

const UserData = React.createContext(null);
export default UserData;
